module.exports = __webpack_public_path__ + "static/media/synth-oof.59ed34ff.webm";